export enum TypeObjetSync {
    ANOMALIE = 'anomalie',
    POINT_AUDIT = 'pointAudit',
    POINT_INSPECTION = 'pointInspection',
    PHOTO = 'photo',
}
